import PermissionsIcon from '@mui/icons-material/Lock';
import PasswordEdit from './PasswordEdit';

export default {
  edit: PasswordEdit,
  ICON: PermissionsIcon,
};